import {
  Avatar as ReactAdminAvatar,
  AvatarProps as ReactAdminAvatarProps,
  SxProps,
  Theme,
} from '@mui/material';

import { colorFromLetter } from '@sh4res/bo-common/fields/AvatarField';

type AvatarProps = ReactAdminAvatarProps & {
  fullName?: string;
  transformName?: (name?: string) => string | undefined;
};

const transformNameDefault = (name?: string) => name?.[0] || '';

export const Avatar = ({
  fullName,
  sx,
  alt,
  transformName = transformNameDefault,
  ...rest
}: AvatarProps) => {
  const color = colorFromLetter(fullName);

  const styles: SxProps<Theme> = {
    ...sx,
    textTransform: 'capitalize',
    backgroundColor: color,
    color: (theme) => theme.palette.getContrastText(color),
  };

  return (
    <ReactAdminAvatar sx={styles} alt={alt ?? fullName} aria-hidden={true} {...rest}>
      {transformName(fullName) || ''}
    </ReactAdminAvatar>
  );
};
